import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Institute Target")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_18 = { class: "col-md-1 mt-2 px-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Training Institute Target List", -1)
const _hoisted_21 = { class: "card mb-5 mb-xl-10" }
const _hoisted_22 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_23 = { class: "row mt-1 w-100 m-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control ps-10 w-200px mt-1 form-control-sm",
      style: {"height":"1em"},
      placeholder: "Search"
    })
  ])
], -1)
const _hoisted_25 = { class: "row w-100 mb-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_27 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_35 = { class: "collapse show" }
const _hoisted_36 = { class: "card-body border-top p-6" }
const _hoisted_37 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_38 = { class: "table-responsive mt-5" }
const _hoisted_39 = { class: "table table-borderless gy-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Institutes"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Target"),
    /*#__PURE__*/_createElementVNode("th", null, "Batch Size")
  ])
], -1)
const _hoisted_41 = { style: {} }
const _hoisted_42 = { class: "align-middle" }
const _hoisted_43 = { class: "align-middle" }
const _hoisted_44 = { class: "align-middle" }
const _hoisted_45 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_46 = ["id", "name", "value", "onKeyup"]
const _hoisted_47 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_48 = ["id", "name", "value", "onKeyup"]
const _hoisted_49 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_TargetDrawer = _resolveComponent("TargetDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (trans) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: trans.id,
                          label: trans.label,
                          value: trans.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(trans.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Partner",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCourseInfo())),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (assoc) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: assoc.id,
                          label: assoc.entity_short_name,
                          value: assoc.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_info_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_info_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTrainingInstitute()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "",
                        label: "Select Course"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Select Course")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseData, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "",
                        label: "Select Institute"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Select Institute")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.courseInfo && _ctx.courseInfo(...args))),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_19
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: _ctx.componentKey,
                    class: "mt-5"
                  }, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_29),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_31),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_33)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("table", _hoisted_39, [
                                  _hoisted_40,
                                  _createElementVNode("tbody", _hoisted_41, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info, idx) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: idx,
                                        style: {"border-bottom":"1px solid\r\n                                        rgba(29, 182, 140, 0.51) !important"}
                                      }, [
                                        _createElementVNode("td", _hoisted_42, _toDisplayString(idx + 1), 1),
                                        _createElementVNode("td", _hoisted_43, _toDisplayString(info?.course_name) + " | " + _toDisplayString(info?.month) + " | " + _toDisplayString(info?.hour) + " | " + _toDisplayString(info?.unit_cost_total), 1),
                                        _createElementVNode("td", _hoisted_44, _toDisplayString(info?.institute_name), 1),
                                        (_ctx.entity_type != 1011)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                              _createElementVNode("input", {
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                id: _ctx.target,
                                                name: `target_[${idx}]`,
                                                value: info?.trainee_target,
                                                onKeyup: _withKeys(($event: any) => (_ctx.targetSet(info, idx)), ["enter"])
                                              }, null, 40, _hoisted_46)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.entity_type == 1011)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                              _createElementVNode("input", {
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                id: _ctx.target,
                                                name: `target_[${idx}]`,
                                                value: info?.trainee_target,
                                                onKeyup: _withKeys(($event: any) => (_ctx.targetSet(info, idx)), ["enter"]),
                                                disabled: ""
                                              }, null, 40, _hoisted_48)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", _hoisted_49, _toDisplayString(info?.trainee_per_batch) + " | " + _toDisplayString(info?.total_target_trainee), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _createVNode(_component_TargetDrawer)
  ], 64))
}